import React from 'react';
import { useSettings } from '../SettingsContext';

interface BrandingSettingsProps {
  onSave: () => void;
}

const BrandingSettings: React.FC<BrandingSettingsProps> = ({ onSave }) => {
  const { settings, updateSettings } = useSettings();

  const handleBrandingChange = (field: string, value: string) => {
    updateSettings({ portalBranding: { ...settings.portalBranding, [field]: value } });
    onSave();
  };

  const handleCheckoutBrandingChange = (field: string, value: string) => {
    updateSettings({ checkoutConfig: { ...settings.checkoutConfig, [field]: value } });
    onSave();
  };

  return (
    <div className="space-y-8 animate-in slide-in-from-left-4">
      <div className="bg-white dark:bg-slate-800 rounded-[2.5rem] p-10 border border-slate-200 dark:border-slate-700 shadow-sm">
        <h2 className="text-xl font-black text-slate-900 dark:text-white uppercase tracking-widest mb-8">Portal & Checkout Branding</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="space-y-4">
            <div className="space-y-2">
              <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Portal Name</label>
              <input 
                type="text" 
                className="w-full px-6 py-4 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-700 rounded-2xl font-bold text-sm outline-none focus:ring-4 focus:ring-indigo-50"
                value={settings.portalBranding.name}
                onChange={(e) => handleBrandingChange('name', e.target.value)}
                placeholder="SubScale"
              />
            </div>
            <div className="space-y-2">
              <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Razorpay Popup Name</label>
              <input 
                type="text" 
                className="w-full px-6 py-4 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-700 rounded-2xl font-bold text-sm outline-none focus:ring-4 focus:ring-indigo-50"
                value={settings.checkoutConfig.paymentDisplayName || ''}
                onChange={(e) => handleCheckoutBrandingChange('paymentDisplayName', e.target.value)}
                placeholder="SubScale"
              />
            </div>
            <div className="space-y-2">
              <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Logo URL</label>
              <input 
                type="text" 
                className="w-full px-6 py-4 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-700 rounded-2xl font-bold text-sm outline-none focus:ring-4 focus:ring-indigo-50"
                value={settings.portalBranding.logoUrl}
                onChange={(e) => handleBrandingChange('logoUrl', e.target.value)}
              />
            </div>
          </div>
          <div className="space-y-2">
            <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Portal Footer Text</label>
            <textarea 
              className="w-full h-full min-h-[160px] px-6 py-4 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-700 rounded-2xl font-bold text-sm outline-none focus:ring-4 focus:ring-indigo-50 resize-none"
              value={settings.portalBranding.footerText}
              onChange={(e) => handleBrandingChange('footerText', e.target.value)}
            />
          </div>
        </div>
      </div>
      <div className="p-8 bg-indigo-50 dark:bg-indigo-900/20 rounded-[2.5rem] border border-indigo-100 dark:border-indigo-800">
        <p className="text-xs text-indigo-700 dark:text-indigo-300 font-bold leading-relaxed">
          Changes made here are instantly reflected in the customer-facing billing portal and Razorpay checkout modal.
        </p>
      </div>
    </div>
  );
};

export default BrandingSettings;
